const login = {
  'login.loginTitle': '账号登录',
  'login.username.placeholder': '账号',
  'login.password.placeholder': '密码',
  'login.login': '登录',
  'login.msg.empty': ' 账号或密码不能为空',
  'login.msg.loginfail': '登录失败',
  'login.img': 'https://fe-static.cassmall.com/assets/images/20241207135432/login_bg_zh.jpg',
  'login.msg.accountEmpty': '账号为空',
};

export default login;
